import script from "./MachReq.vue?vue&type=script&setup=true&lang=js"
export * from "./MachReq.vue?vue&type=script&setup=true&lang=js"

import "./MachReq.vue?vue&type=style&index=0&id=3e561eed&lang=css"

const __exports__ = script;

export default __exports__